var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtSign = function SvgAtSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.84 2.94A10.112 10.112 0 0 1 22.237 12.1v.95a3.454 3.454 0 0 1-6.516 1.594 4.405 4.405 0 1 1-.39-5.564v-.785a.6.6 0 0 1 1.2 0v4.756a2.254 2.254 0 0 0 4.507 0v-.951A8.913 8.913 0 0 0 8.35 4.027a8.912 8.912 0 1 0 9.123 15.2.6.6 0 1 1 .72.96A10.112 10.112 0 1 1 7.84 2.94m4.286 5.954a3.206 3.206 0 0 0 0 6.409 3.205 3.205 0 0 0 0-6.41"
  })));
};
export default SvgAtSign;